import React, { useState, useEffect, useRef } from 'react';
import './index.css';

const Collapse = props => {
  // eslint-disable-next-line
  const { isOpen = false, children } = props;
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  }, [children]);

  return (
    <div
      ref={ref}
      className="collapse-block"
      style={isOpen ? { maxHeight: height } : undefined}
    >
      {children}
    </div>
  );
};

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/Collapse/index.js